export default __webpack_public_path__ + "static/media/erco.1151ef77.webp";